import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../../../redux'
import { Button } from '../../../../components/ui/button';
import { Download } from 'lucide-react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table'
import { formatCashAmount, splitArrayIntoChunks } from '../../../../lib/utils';
import { Pagination } from '../../../../components/ui/pagination';
import { convertToDate, convertToHHMM } from '../../../../lib/date';
import { format } from 'date-fns';
import ExportTable from '../../../../components/portal/export/ExportTable';
import { createExport, createExportObject, createExportRows } from '../../../../lib/general/export';
import useAuth from '../../../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

type Props = {
    keepsafes: CountKeepsafe[]
}


const CountKeepsafesTable : React.FC<Props> = ({keepsafes}) => {
    const {auth} = useAuth()
    const {t} = useTranslation()
    const headerArr = [t("track_and_trace.partner_nr"), t("track_and_trace.partner"), t("track_and_trace.customer_nr"), t("track_and_trace.customer_code"), t("track_and_trace.customer"), t("track_and_trace.barcode"), t("track_and_trace.motherks"), t("track_and_trace.dtstock"), t("track_and_trace.borderel"), t("track_and_trace.bgannounced"), t("track_and_trace.bgcount"), t("track_and_trace.bgdamaged"), t("track_and_trace.bgfalse"), t("track_and_trace.bginkstained")]
    const navigate = useNavigate()

    const partners = useSelector((state:RootState)=>state.partners);
    const customers = useSelector((state:RootState)=>state.unfilteredCustomers);

    const [currentPage, setcurrentPage] = useState<number>(1);

  return (
    <>
    {auth.data?.right.export && 
    <div className='flex justify-end mt-4'>    
        <ExportTable onDownload={(extension)=>{createExport(auth.data?.token || '', extension, createExportObject(headerArr, createExportRows(keepsafes, ['partnerid', 'partnername', 'relnr', 'customerclientcode', 'customername', 'barcode', 'motherks', 'dtstock', 'borderel', 'bgannounced', 'bgcount', 'bgdamaged', 'bgfalse', 'bginkstained'], {partners:partners, customers:customers, relnr:'relnr'})))}}/>
    </div>
    }

    <div className='my-4 border rounded-sm'>
        <Table>
            <TableHeader className='relative bg-slate-100'>
                <TableRow>
                    <TableHead className='uppercase'>{t("track_and_trace.partner")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.customer")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.customer_code")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.barcode")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.motherks")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.dtstock")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.borderel")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.bgannounced")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.bgcount")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.bgdamaged")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.bgfalse")}</TableHead>
                    <TableHead className='uppercase'>{t("track_and_trace.bginkstained")}</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {keepsafes && splitArrayIntoChunks(keepsafes, 20)[currentPage - 1] && splitArrayIntoChunks(keepsafes, 20)[currentPage - 1].map((keepsafe, index)=>{
                    let relation = customers.find(obj => obj.eindklant.some(e => e.relnr === keepsafe?.relnr))
                    let partner = partners.find(obj => obj.relnr === relation?.id)
                    let customer = customers.flatMap(obj => obj.eindklant).find(e => e.relnr === keepsafe?.relnr)
                    
                    return (
                    <TableRow className='cursor-pointer' onClick={()=>{navigate(`count/${keepsafe?.barcode ? keepsafe.barcode : '_'}${keepsafe.colliid ? `?colli_id=${keepsafe.colliid}` : ''}`, {state:keepsafe})}} key={index}>
                        <TableCell>{partner?.name}</TableCell>
                        <TableCell>{customer?.name}</TableCell>
                        <TableCell>{customer?.clientcode}</TableCell>
                        <TableCell>{keepsafe?.barcode}</TableCell>
                        <TableCell>{keepsafe?.motherks}</TableCell>
                        <TableCell>{keepsafe?.dtstock ? format(convertToDate(keepsafe.dtstock)!, "dd/MM/yyyy") : ''}</TableCell>
                        <TableCell>{keepsafe?.borderel}</TableCell>
                        <TableCell className='text-right'>{keepsafe?.bgannounced ? formatCashAmount(keepsafe?.bgannounced) : ''}</TableCell>
                        <TableCell className='text-right'>{keepsafe?.bgcount ? formatCashAmount(keepsafe?.bgcount) : ''}</TableCell>
                        <TableCell className='text-right'>{keepsafe?.bgdamaged ? formatCashAmount(keepsafe?.bgdamaged) : ''}</TableCell>
                        <TableCell className='text-right'>{keepsafe?.bgfalse ? formatCashAmount(keepsafe?.bgfalse) : ''}</TableCell>
                        <TableCell className='text-right'>{keepsafe?.bginkstained ? formatCashAmount(keepsafe?.bginkstained) : ''}</TableCell>
                    </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    </div>
                
    <Pagination totalItems={keepsafes.length} itemsPerPage={20} page={currentPage} onPageChange={(page)=>{ setcurrentPage(parseFloat(page)) }}/>
    </>
  )
}

export default CountKeepsafesTable